import LTR from "@brand-icons/global/smoke/smoke-ltr.svg";

import { iconFactory } from "../iconFactory";

export const SmokeIcon = iconFactory("SmokeIcon", LTR);
